import { Typography } from "antd";
import styled from "styled-components";

export const StyledCustomerHeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 10px;
  border-radius: 20px;
  margin-bottom: 10px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`;

export const StyledCustomerHeaderBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledCustomerHeaderBarInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;

  .ant-typography {
    line-height: 1.2;
  }
`;

export const StyledCustomerName = styled(Typography.Text)`
  font-size: 16px;
  font-weight: 600;
`;

export const StyledCustomerWelcome = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 400;
`;

export const StyledCustomerHeaderBarRight = styled.div``;
